import React, { useEffect, useState } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import StickyNavbar from '../StickyNavBar/StickyNavBar';
import { getUserPictureObjectUrl, getUserInfo } from '../../apiRequests/graph/graph';
import type { IUserInfo } from '../../interfaces';
import { acquireAccessTokenAsync } from '../../AuthHelper';

export interface IPageLayoutProps extends React.PropsWithChildren {
  onWaffleClick(): void;
}

/**
 * Renders the navbar component and the other components of the page 
 * @param props
 */
export const PageLayout = (props: IPageLayoutProps) => {
  const { onWaffleClick } = props;
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [imageUrl, setImageUrl] = useState("");
  const [userData, setuserData] = useState<IUserInfo | undefined>();

  useEffect(() => {
    if (account) {
      acquireAccessTokenAsync(instance, account, ["User.Read"])
        .then((accessToken) => {
          return Promise.all([
            getUserPictureObjectUrl(accessToken).then(setImageUrl),
            getUserInfo(accessToken).then(setuserData),
          ]);
        })
        .catch((error) => {
          console.error("Error acquiring access token or fetching user data:", error);
        });
    }
  }, [account, instance]);

  return (
    <div>
      <StickyNavbar imageUrl={imageUrl} userData={userData} onWaffleClick={onWaffleClick} />
      <div style={{ padding: '20px' }}>
        {props.children}
      </div>
    </div>
  );
};

